import { axiosInstance } from '@/utils/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { env } from '@/utils/constants/env';

export type IEmployee = {
  username: string;
  fullname: string;
  email: string;
};

export const FreeipaService = {
  useGetEmployees: () =>
    useQuery<IEmployee[]>({
      queryKey: ['employees'],
      queryFn: async () => {
        const { data } = await axiosInstance.get(env.apiTasklistBaseUrl + '/api/v1/freeipa/users');
        return data.data;
      },
    }),
};
